"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParentalConsent = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _useTranslations_simplifiedRegistrationBrandPartner = require("../../hooks/useTranslations_simplified-registration-BrandPartner");
var _models = require("../../models");
var _jsxRuntime = require("react/jsx-runtime");
const ParentalDescriptionStyled = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  margin: theme.spacing(3, 0),
  textAlign: 'left'
}));
const ParentalConsent = ({
  config,
  handleCheckbox,
  isUnderParentalConsentAge
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _useTranslations_simplifiedRegistrationBrandPartner.useTranslations)();
  const [expanded, setExpanded] = (0, _react.useState)(false);
  const [isCheckBoxDisabled, setIsCheckBoxDisabled] = (0, _react.useState)(false);
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    customErrors
  } = errorData;
  const form = (0, _reactHookForm.useFormContext)();
  const {
    formState: {
      isSubmitting
    }
  } = form;
  const isCheckboxChecked = Boolean(form.watch('parentalConsent.isChecked'));
  const isEmailAvaliable = config?.email?.isAvailable;
  const isPhoneAvaliable = config?.telephone?.isAvailable;
  const handleExpandClick = (0, _react.useCallback)(() => {
    setExpanded(prev => !prev);
  }, []);
  const handleCheckboxChange = (0, _react.useCallback)(async checked => {
    handleCheckbox?.(checked);
    form.setValue('parentalConsent.isChecked', checked);
    if (!isCheckboxChecked) {
      form.clearErrors(['parentalConsent.telephone', 'parentalConsent.email']);
      form.reset({
        ...form.getValues(),
        parentalConsent: {
          ...form.getValues('parentalConsent'),
          email: undefined,
          telephone: undefined
        }
      });
    }
  }, [handleCheckbox, form, isCheckboxChecked]);
  (0, _react.useEffect)(() => {
    if (isUnderParentalConsentAge) {
      const isAlreadyChecked = form.getValues('parentalConsent.isChecked');
      if (!isAlreadyChecked) {
        handleCheckboxChange(true);
      }
      setExpanded(true);
      setIsCheckBoxDisabled(true);
    }
  }, [isUnderParentalConsentAge, handleCheckboxChange, form]);
  const correctBoxMarginBottom = expanded && isCheckboxChecked ? -2 : expanded ? 0 : 3;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    ...getTestIdProps('parentalConsent-sponsorForm'),
    sx: {
      order: 99,
      width: '100%',
      marginTop: 6,
      marginBottom: correctBoxMarginBottom
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      onClick: handleExpandClick,
      sx: {
        cursor: 'pointer',
        display: 'flex'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentTitle,
          id: _models.TranslationKey.ParentalConsentTitle,
          values: {
            parentalConsentAge: config?.parentalConsentAge
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowDownThin, {
        sx: {
          transform: expanded ? 'rotateX(180deg)' : '0',
          transition: 'all 0.2s ease-in-out'
        }
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Collapse, {
      unmountOnExit: true,
      in: expanded,
      timeout: "auto",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ParentalDescriptionStyled, {
        variant: "body1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentDescription,
          id: _models.TranslationKey.ParentalConsentDescription,
          values: {
            minAge: config?.minAge,
            parentalConsentAge: config?.parentalConsentAge
          }
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.CheckboxFormFieldByConfig, {
        isAvailable: true,
        name: "parentalConsent.isChecked",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "body1",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
            defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentCheckboxLabel,
            id: _models.TranslationKey.ParentalConsentCheckboxLabel,
            values: {
              parentalConsentAge: config?.parentalConsentAge
            }
          })
        }),
        displayOrder: 1,
        isSubmitting: isSubmitting || isCheckBoxDisabled,
        onChange: async e => handleCheckboxChange(e.target.checked)
      }), isPhoneAvaliable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.PhoneFieldByConfig, {
        name: "parentalConsent.telephone",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentPhone,
          id: _models.TranslationKey.ParentalConsentPhone
        }),
        labelWithPrefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentPhoneWithPrefix,
          id: _models.TranslationKey.ParentalConsentPhoneWithPrefix
        }),
        helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.ParentalConsentTooltipPhone,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentTooltipPhone
        }),
        helperTextWithPrefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.ParentalConsentTooltipPhoneWithPrefix,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentTooltipPhoneWithPrefix
        }),
        customPlaceholder: formatMessage(_models.TranslationKey.ParentalConsentPlaceholderPhone),
        customPlaceholderWithPrefix: formatMessage(_models.TranslationKey.ParentalConsentPlaceholderPhone),
        ...config.telephone,
        isAvailable: isCheckboxChecked,
        isMandatory: config.telephone?.validation?.isMandatory,
        customErrors: customErrors
      }) : null, isEmailAvaliable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.TextFormFieldByConfig, {
        enableLowercaseLetters: true,
        name: "parentalConsent.email",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentEmail,
          id: _models.TranslationKey.ParentalConsentEmail
        }),
        helperText: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ParentalConsentEmailTooltip,
          id: _models.TranslationKey.ParentalConsentEmailTooltip
        }),
        customPlaceholder: formatMessage(_models.TranslationKey.ParentalConsentEmailPlaceholder),
        keyboardType: "email",
        ...config.email,
        isAvailable: isCheckboxChecked,
        isMandatory: config.email?.validation?.isMandatory,
        maxLengthLimit: config.email?.validation?.maxLength,
        customErrors: customErrors
      }) : null]
    })]
  });
};
exports.ParentalConsent = ParentalConsent;